module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Annie Solomon\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("A native New Yorker, RITA-winning author "), _c('B', [_vm._v("Annie Solomon")]), _vm._v(" has been dreaming up stories since she was ten. After a twelve-year career in advertising, where she rose to Vice President and Head Writer at a mid-size agency, she abandoned the air conditioners, furnaces, and heat pumps of her professional life for her first love: romance.  An avid knitter and mother of a daughter attending college, she now lives in Nashville with her husband. You can visit her Web site at "), _c('a', {
    attrs: {
      "href": "http://www.anniesolomon.net/"
    }
  }, [_vm._v("www.anniesolomon.net")]), _vm._v("."), _c('br')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/11eKxwB/images/9780446565851.jpg?1733067604660",
      "alt": "This image is the cover for the book Two Lethal Lies"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Two Lethal Lies\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A love to die for..."), _c('br'), _c('br'), _vm._v(" On the run since his daughter was born, Mitch Turner has concealed a truth so dangerous, its discovery could jeopardize both their lives.  But when a series of shocking murders hits their newfound home, the trail leads straight to Mitch.  With the police out for blood and his daughter ripped from his arms, he has nowhere to turn--until a beautiful stranger offers her help."), _c('br'), _c('br'), _vm._v(" Neesy Brown has made mistakes in her life, yet she refuses to believe this mysterious man is a killer.  There's a strength in his broad shoulders that draws her to him and a weariness in his eyes that she longs to ease.  As the murders tear her small town apart, she vows to help Mitch find his missing child.  But a cunning predator is pulling them deeper and deeper into his fatal game.  And the price of losing is the child--and the future--they could both share...")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Grand Central Publishing\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0